module.exports = __webpack_public_path__ + "img/top_happytable.2ea8cc4a.jpg";